module.exports = __webpack_public_path__ + "static/media/layer-dark.94049f0c.svg";